import { homeownerQuotesService } from '@/services/quotes/homeowner';
import {
  CreateQuotePayload,
  CreateQuoteResponse,
} from '@/services/quotes/types';
import { useMutation } from '@tanstack/react-query';

export function useCreateQuote() {
  return useMutation<
    { success: boolean; data?: CreateQuoteResponse; error?: string },
    Error,
    CreateQuotePayload
  >({
    mutationKey: ['quotes', 'create'],
    mutationFn: async (payload: CreateQuotePayload) => {
      const response = await homeownerQuotesService.createQuote(payload);
      if (!response.success) throw new Error(response.error || 'Erro');
      return response;
    },
  });
}
